import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Modal, Nav, Navbar, Form, Dropdown, Button } from "react-bootstrap";
import { Container, Row, Col, Offcanvas } from "react-bootstrap";
import MenuIcon from "../assets/svg/MenuIcon";
import MenuIcon1 from "../assets/images/icons/menuicon.png";
import ProfileIcon from "../assets/svg/ProfileIcon";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WalletIcon from "../assets/svg/WalletIcon";
import BetIcon from "../assets/svg/BetIcon";
import SettingIcon from "../assets/svg/SettingIcon";
import StatementIcon from "../assets/svg/StatementIcon";
import LogoutIcon from "../assets/svg/LogoutIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import logo from "../assets/images/logo.webp";
import TextLogo from "../assets/images/logo-text.png";
import CashierIcon from "../assets/svg/CashierIcon";
import GamesIcon from "../assets/svg/GamesIcon";
import HomeIcon from "../assets/svg/HomeIcon";
// import RiExchangeFill from "../assets/svg/ProfileIcon";
import Exchange from "../assets/images/Exchange.png";
import SportsIcon from "../assets/svg/SportsIcon";
import numberWithCommas from "../utils/numbersWithComma";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { IoWalletOutline } from "react-icons/io5";
import ExchangeFundsFormPopUp from "../views/components/ExchangeFundsFormPopUp";
import { CasinoProviders } from "../lib/data";
// import Index from "../views/pages/privatePages/exchangepopup";
import { getExposureAmount } from "../redux/auth/actions";
import { getBetMatches, getUserBet } from "../redux/sports/actions";

import HomeIcon1 from "../assets/images/games-icon/home-icon1.png";
import EzugiIcon from "../assets/images/games-icon/Ezugi.png";
import EvolutionIcon from "../assets/images/games-icon/Evolution.png";
import CashierIcon1 from "../assets/images/games-icon/cashier.png";

import SportsIconNew from "../assets/images/games-icon/headicon/sports.svg";
import CashierIconNew from "../assets/images/games-icon/headicon/cashier.svg";
import EzugiIconNew from "../assets/images/games-icon/headicon/roulette.svg";
import EvolutionIconNew from "../assets/images/games-icon/headicon/table-games-new.svg";
import HomeIConNew from "../assets/images/games-icon/headicon/house.png";
import casinoround from "../assets/images/games-icon/headicon/spin_bg.png";
import casinogame from "../assets/images/games-icon/headicon/turntable.png";
import casinopoint from "../assets/images/games-icon/headicon/pointer.png";
import Bonus from "../assets/images/bonus.png";
import BotHeadIcon1 from "../assets/images/games-icon/play3d.png";
import BotHeadIcon2 from "../assets/images/games-icon/cricket-icon.png";
import BotHeadIcon3 from "../assets/images/games-icon/football.png";
import BotHeadIcon4 from "../assets/images/games-icon/plane.png";
import BotHeadIcon5 from "../assets/images/games-icon/dragon.png";
import BotHeadIcon6 from "../assets/images/games-icon/cards.png";
import BotHeadIcon7 from "../assets/images/games-icon/fortune-wheel.png";
import Referral from "../assets/images/refferal.png";
import Bonus1 from "../assets/images/bonus.png";

import BonusIcon from "../assets/images/icons/gift.png";
import SportsIcon1 from "../assets/images/icons/Sports-white.png";
import SearchIcon from "../assets/images/icons/find.png";
import WalletIcon1 from "../assets/images/icons/deposit-icon.png";

import BonusIcon1 from "../assets/images/icons/Bonus.png";
import AccountStatement1 from "../assets/images/icons/Account-setting.png";
import ReferralIcon1 from "../assets/images/icons/withdraw.png";
import MyBets1 from "../assets/images/icons/Account-statement.png";
import SignOut1 from "../assets/images/icons/signout.png";
import ProfileIcon1 from "../assets/images/icons/Profile.png";
import { handleRightSideBar } from "../redux/app/actions";

import FetchingBal from "../assets/images/icons/fetch.gif";
import refferal from "../assets/images/Reffral.png";
import { AiOutlineClose } from "react-icons/ai";
import StarIcon from "../assets/images/icons/Gold-Shine-PNG-Image.png";
import Promotionicon from "../assets/images/icons/Promotion.png";
import AppDownload from "../assets/images/icons/download.png";

import EzugiIconew from "../assets/images/icons/ezugiivon.png";
import SlotsIconnew from "../assets/images/icons/jackpot.png";
import EvolutionIconew from "../assets/images/icons/cards.png";
import AviatorICon from "../assets/images/icons/aeroplane.png";
import Supernvowa from "../assets/images/icons/supernowaicon.png";
import SpribeIcon from "../assets/images/icons/airplane-accident.png";
import Dice from "../assets/images/icons/dice.png";
import GamesSearchModal from "../views/components/GamesSearchModal";

import ProfileIconnew from "../assets/images/icons/profile1.png";
import LanguageChange from "../views/components/LanguageChange";
import { ImCross } from "react-icons/im";
import TawkChat from "../views/components/TawkChat";

import { getNotifications } from "../redux/app/actions";

import Slots from "../assets/images/games-icon/leftbar/slots.png";
import Sportsbook from "../assets/images/games-icon/leftbar/sports.png";
import CustomLanguageSelector from "../views/components/CustomLanguageSelector";
import { useTranslation } from "react-i18next";

const HeaderAfterLogin = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const isBonus = numberWithCommas(wallet?.coins) || 0;
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const { showRightSideBar } = useSelector((state) => state.app);
  const [showBalance, setShowBalanceLoading] = useState(false);
  const [isLanguageShow, setIsLanguageShow] = useState(true);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const [showToggle, setShowToggle] = useState(true);
  const { t } = useTranslation();

  const handleClose = () => {
    handleSideBarVisibility(false);
    setShow(false);
  };
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showexchangeModal, setShowexchangeModal] = useState(false);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [visible, setVisible] = useState(true);
  const [fontConfig, setFontConfig] = useState({
    counter: 0,
    fontSize: 12,
    type: "inc",
  });
  const isApk = localStorage.getItem("isApk") === "true";

  useEffect(() => {
    if (visible) {
      document.body.classList.add("welcome_note");
    } else {
      document.body.classList.remove("welcome_note");
    }
  }, [visible]);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const headerPages = [
    "betby",
    "casino/ezugi",
    "Slots",
    "casino/evolution",
    "casino/spribe/aviator",
    "Spribe",
    "casino/vivo",
    "qtechlobby",
    "sports",
  ];
  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);
  useEffect(() => {
    // dispatch(getExposureAmount());
    // dispatch(getBetMatches({ status: "pending" }));
    setShowToggle(window.screen.width > 992);
    let intervalID = setInterval(() => {
      setShowBalanceLoading((p) => !p);
    }, 5000);
    return () => {
      clearInterval(intervalID);
    };
  }, []);

  useEffect(() => {
    setShowToggle(window.screen.width > 992);
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const [showLightModeToggle, setShowLightModeToggle] = useState(false);
  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  useEffect(() => {
    if (showLeftbarToggle) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  const handleSideBarVisibility = (value) => {
    dispatch(handleRightSideBar(value));
  };
  const handleFontConfig = () => {
    if (fontConfig.counter <= 2 && fontConfig.type == "inc") {
      if (fontConfig.counter === 2) {
        setFontConfig((p) => ({
          ...p,
          counter: p.counter - 1,
          fontSize: p.fontSize - 2,
          type: "dec",
        }));
      } else {
        setFontConfig((p) => ({
          ...p,
          counter: p.counter + 1,
          fontSize: p.fontSize + 2,
        }));
      }
    } else if (fontConfig.counter >= 0 && fontConfig.type == "dec") {
      if (fontConfig.counter === 0) {
        setFontConfig((p) => ({
          ...p,
          counter: p.counter + 1,
          fontSize: p.fontSize + 2,
          type: "inc",
        }));
      } else {
        setFontConfig((p) => ({
          ...p,
          counter: p.counter - 1,
          fontSize: p.fontSize - 2,
        }));
      }
    }
  };

  const renderBalance = () => {
    return (
      <>
        <div className="cashloader">
          <div className="balance-web">
            <ul>
              <li>
                {t("cash")}: <span>{numberWithCommas(wallet?.cash || 0)}</span>
              </li>
              {isBonus != 0 && (
                <li>
                  {t("Coins")}:<span> {numberWithCommas(wallet?.coins)}</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {" "}
            {websiteNotifications.map((notf, idx) => (
              <label>
                <img src={StarIcon} alt="star icon" />
                {notf?.content}
                <img src={StarIcon} alt="star icon" />
              </label>
            ))}
          </marquee>
          <span onClick={() => setVisible(!visible)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="d-flex ju stify-content-between align-items-center">
                  <div className="d-flex align-items-center afterloginsection">
                    <div className="leftbar_toggle d-md-none d-block ">
                      <Button
                        variant="primary"
                        onClick={() => setShowLeftbarToggle((s) => !s)}
                      >
                        <img src={MenuIcon1} />
                      </Button>
                    </div>

                    <div className="headerRight">
                      <div className="logo">
                        <a href="/home">
                          <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
                          {/* <img src={TextLogo} alt="Logo" className="logotext" /> */}
                        </a>
                      </div>
                      {/* <a href="/wallet" className="headicons depositbtn">
                        <img src={WalletIcon1} /> Deposit
                      </a> */}
                    </div>
                  </div>

                  <div className="headerRight headerrightsec">
                    {/* <div className="head-links d-none d-lg-flex">
                      <a href="/slots-games">
                        <img src={Slots} alt="slots" />
                        <span>Slots</span>
                      </a>
                      <a href="/atlas-lobby">
                        <img src={Sportsbook} alt="sportsbook" />
                        <span>Sportsbook</span>
                      </a>
                    </div> */}

                    <div className="LanguageCancelSection">
                      {/* <CustomLanguageSelector/> */}

                      <div className={isLanguageShow ? "" : "d-none"}>
                        <LanguageChange />
                      </div>
                      {isLanguageShow && (
                        <div
                          onClick={() => setIsLanguageShow((prev) => !prev)}
                          className="LanguageCancel"
                        >
                          <ImCross />
                        </div>
                      )}
                    </div>

                    <div className="d-md-flex align-items-center d-none">
                      <GamesSearchModal />

                      <a href="/wallet" className="headicons depositbtn">
                        <img src={WalletIcon1} /> {t("deposit")}
                      </a>
                    </div>

                    {renderBalance()}

                    <div className="funds">
                      <ul>
                        <Dropdown
                          className="headerMainDropdown d-block d-md-none"
                          placement={"end"}
                        >
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            className="deposit"
                          >
                            {t("deposit")}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item href="">
                              <div className="row">
                                <div className="col-6">
                                  <div className="balance mb-1">
                                    {t("mainBalance")}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="balance-amount mb-1">
                                    {wallet?.balance}
                                  </div>
                                </div>
                              </div>
                            </Dropdown.Item>
                            <Dropdown.Item href="">
                              <div className="row">
                                <div className="col-6">
                                  <div className="balance mb-1">Cash</div>
                                </div>
                                <div className="col-6">
                                  <div className="balance-amount mb-1">
                                    {numberWithCommas(wallet?.cash)}
                                  </div>
                                </div>
                              </div>
                            </Dropdown.Item>
                            <Dropdown.Item href="">
                              <div className="row">
                                <div className="col-6">
                                  <div className="balance mb-1">
                                    {t("bonus")}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="balance-amount mb-1">
                                    {numberWithCommas(wallet?.coins)}
                                  </div>
                                </div>
                              </div>
                            </Dropdown.Item>
                            {/* {isBonus != 0 && (
                              <Dropdown.Item href="">
                                <div className="row">
                                  <div className="col-6">
                                    <div className="balance ">{t ("bonus")}</div>
                                  </div>
                                  <div className="col-6">
                                    <div className="balance-amount">
                                      {numberWithCommas(wallet?.coins) || 0}
                                    </div>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            )} */}
                            <Dropdown.Item href="">
                              <div
                                onClick={() => {
                                  navigate("/gatewaylist");
                                }}
                              >
                                <Button
                                  variant="primary w-100 "
                                  className="depositbtn"
                                >
                                  {t("deposit")}
                                </Button>
                              </div>
                              <div
                                onClick={() => {
                                  navigate("/withdraw");
                                }}
                              >
                                <Button
                                  variant="primary w-100"
                                  className="withdraw"
                                >
                                  {t("withdraw")}
                                </Button>
                              </div>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </ul>
                    </div>

                    <Button
                      variant="primary menu-btn "
                      className="d-none d-md-block"
                      onClick={() => handleSideBarVisibility(true)}
                    >
                      <ProfileIcon />
                      {/* <MenuIcon /> */}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Offcanvas
          show={showRightSideBar}
          onHide={handleClose}
          placement={"end"}
          className="menuDropdown"
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="black">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={ProfileIconnew} alt="ProfileIconnew" />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  <a href="#">{user?.mobileno}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row offcanvas-head">
              <div className="col-6">
                <div className="balance mb-1">{t("mainBalance")}</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              {isBonus != 0 && (
                <>
                  <div className="col-6">
                    <div className="balance mb-3">{t("coins")}</div>
                  </div>
                  <div className="col-6">
                    <div className="balance-amount mb-3">
                      {numberWithCommas(wallet?.coins) || 0}
                    </div>
                  </div>
                </>
              )}
              <div className="col-6 ">
                <a href="/withdraw" className="btn btn-secondary w-100">
                  {t("withdraw")}
                </a>
              </div>
              <div className="col-6">
                <a href="/gatewaylist" className="btn btn-primary w-100">
                  {t("deposit")}
                </a>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img src={ProfileIcon1} />
                  <span>{t("profile")}</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MyBets1} />
                  <span>{t("casinoBets")}</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={refferal} />
                  <span>{t("referral")}</span>
                </a>
              </li>
              <li>
                <a href="/promotion">
                  <img src={Promotionicon} />
                  <span>{t("promotions")}</span>
                </a>
              </li>

              <li>
                <a href="/cashier">
                  <img src={AccountStatement1} />
                  <span>{t("accountStatement")}</span>
                </a>
              </li>

              <li>
                <a href="/bonus" className="">
                  <img src={BonusIcon} /> {t("bonus")}
                </a>
              </li>
              <li
                onClick={() => {
                  dispatch(logoutUser());
                }}
              >
                <a href="#">
                  <img src={SignOut1} />
                  <span>{t("signOut")}</span>
                </a>
              </li>
            </ul>
            {/* <ul className="social_links">
              <li>
                <a
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <TelegramIcon />
                </a>
              </li>

              <li className="theme-btn">
                <buton
                  type="button"
                  onClick={() => setShowLightModeToggle((s) => !s)}
                >
                  <div className="theme-icon">
                    <img
                      src={MoonLight}
                      alt="Moon Icon"
                      className="dark_theme"
                    />
                    <img
                      src={SunLight}
                      alt="Sun Icon"
                      className="light_theme"
                    />
                  </div>
                </buton>
              </li>
            </ul> */}
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{t("exposureAmount")}</th>
                      <th scope="col">{t("matchName")}</th>
                      <th scope="col">{t("refMatchID")}</th>
                      <th scope="col">{t("totalBets")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{t("odds")}</th>
                      <th scope="col">{t("stack")}</th>
                      <th scope="col">{t("selectionType")}</th>
                      <th scope="col">{t("status")}</th>
                      <th scope="col">{t("createDate")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <div className="bottom_head">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul style={{ fontSize: `${fontConfig.fontSize}px` }}>
                  <li>
                    <a
                      href="/exchange/Inplay"
                      className={activePage == "betby" ? "active" : ""}
                    >
                      <img
                        src={BotHeadIcon1}
                        alt="bottom head link icon"
                        className="inplay"
                      />
                      <span>{t("inplay")}</span>
                    </a>
                  </li>

                  <li>
                    <a
                      href="/provider"
                      className={
                        activePage == "/casino/supernowa" ? "active" : ""
                      }
                    >
                      <img src={Supernvowa} alt="bottom head link icon" />
                      <span>{t("casino")}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/exchange/Inplay"
                      className={
                        activePage == "casino/evolution" ? "active" : ""
                      }
                    >
                      <img src={EvolutionIconew} alt="bottom head link icon" />
                      <span>{t("exchange")}</span>
                    </a>
                  </li>

                  <li>
                    <a
                      href="/promotion"
                      className={activePage == "Spribe" ? "active" : ""}
                    >
                      <img src={SpribeIcon} alt="bottom head link icon" />
                      <span>{t("promotions")}</span>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>

        <TawkChat />
      </header>
    </>
  );
};

export default HeaderAfterLogin;
